const theme = {
  colors: {
    primary: '#3A8FFF',
    primaryLight: '#E5EDFC',
    secondary: '#3C435C',
    secondaryLight: '#A8ABB6',
    green: '#2CBD9B',
    red: '#EE5361',
    yellow: '#FFCA2E',
    white: '#FFFFFF',
    lightGreen: '#EAF9F5',
    gray: '#FAF8FA',
    lightGray: '#C9C9C9',
    darkGray: '#707070',
    lightBlue: '#b0d2ff',
    highlighted: '#63ACFF',
    highlightedPrimary: '#78b1fc',
    highlightedSecondary: '#575c6e',
    highlightedRed: '#ff8590',
    highlightedGreen: '#77cfbb',
    highlightedYellow: '#FFEA61',
    orange: '#ea8023',
    darkOrange: '#f8770c',
    tenderBlue: '#bfdaff',

    background: {
      primaryLight: '#3A8FFF66',
    },

    text: {
      primary: '#3C435C',
      secondary: '#7A829B',
      white: '#FFFFFF',
      red: '#EE5361',
    },
  },

  aboveWidth: {
    0: 'calc(70vw - 100px)',
    1: '20vw',
    2: '10vw',
  },
};

export default theme;
